
import { Component, Input, output } from '@angular/core';
import { GoogleMapsModule, } from '@angular/google-maps';

@Component({
    selector: 'app-google-map',
    templateUrl: './google-map.component.html',
    styleUrl: './google-map.component.css',
    imports: [
    GoogleMapsModule
]
})
export class GoogleMapComponent {
  @Input() height: string = '500px'; // Default height
  @Input() drawingMode: google.maps.drawing.OverlayType.CIRCLE | google.maps.drawing.OverlayType.POLYGON = google.maps.drawing.OverlayType.CIRCLE;
  pathCoordinates = output<any>();
  @Input() defaultShapes: { type: string; polygon?: any, circle?: any }[] = [];
  // @Input() outerShape: { type: string; polygon?: any, circle?: any } = {
  //   "type": "Polygon",
  //   "polygon": {
  //     "coordinates": [
  //       [
  //         17.409529258495553,
  //         78.44049879708356
  //       ],
  //       [
  //         17.419356854283766,
  //         78.5220379511363
  //       ],
  //       [
  //         17.39232969409723,
  //         78.51319739022321
  //       ],
  //       [
  //         17.390855370441006,
  //         78.44084211983747
  //       ]
  //     ]
  //   }
  // };
  // @Input() outerShape: { type: string; polygon?: any, circle?: any } = {
  //   "circle": {
  //     "center": [
  //       17.305994706297106,
  //       78.60690435968236
  //     ],
  //     "radius": 65.00488137191546
  //   },
  //   "polygon": {
  //     "coordinates": []
  //   },
  //   "type": "Circle"
  // }

  @Input() outerShape: { type: string; polygon?: any, circle?: any };

  map!: google.maps.Map;
  outerCircle!: any;
  outerPolygon: any;
  drawingManager!: any;
  shapes: google.maps.MVCArray<google.maps.Polygon | google.maps.Circle> = new google.maps.MVCArray();
  defaultLocation = { lat: 17.4065, lng: 78.4772 };
  currentOverlay: google.maps.Circle | google.maps.Polygon | null = null;
  autocomplete!: google.maps.places.Autocomplete;

  ngOnChanges(simpleChange): void {
    console.log(simpleChange);
    // console.log(this.defaultShapes);
    if (!this.drawingMode) this.drawingMode = google.maps.drawing.OverlayType.CIRCLE;
    if (simpleChange.drawingMode && simpleChange.drawingMode.currentValue) {
      this.currentOverlay = null;
    }
    this.initMap();
  }

  initMap(): void {
    const initializeMap = (location: { lat: number; lng: number }) => {
        this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
            center: new google.maps.LatLng(location.lat, location.lng),
            zoom: 14,
            mapId: "GM_MAP_ID",
        });

        this.initDrawingManager();
        this.loadDefaultShapes();
        this.initAutoSearch(location);
    };

    const handleGeolocationError = (error: GeolocationPositionError) => {
        console.error('Error getting user location:', error);

        let errorMessage: string;
        switch (error.code) {
            case error.PERMISSION_DENIED:
                errorMessage = 'Permission denied. Using fallback location.';
                break;
            case error.POSITION_UNAVAILABLE:
                errorMessage = 'Position unavailable. Using fallback location.';
                break;
            case error.TIMEOUT:
                errorMessage = 'Geolocation request timed out. Using fallback location.';
                break;
            default:
                errorMessage = 'Unknown error. Using fallback location.';
                break;
        }

        console.warn(errorMessage);
        this.initFallbackMap();
    };

    if (navigator.geolocation && this.defaultShapes.length === 0) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const userLocation = this.defaultShapes.length !== 0
                    ? this.getLocationPoints()
                    : {
                          lat: position.coords.latitude,
                          lng: position.coords.longitude,
                      };

                initializeMap(userLocation);
            },
            handleGeolocationError,
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            }
        );
    } else {
        this.initFallbackMap();
    }
}

  initAutoSearch(currentLatLngView) {
    // this.geocoder = new google.maps.Geocoder();
    const searchInput = document.getElementById('search-map-input') as HTMLInputElement;
    this.autocomplete = new google.maps.places.Autocomplete(searchInput, {
      types: ['geocode'], //['premise']
      // strictBounds: true,
      bounds: this.createBoundsAroundLocation(currentLatLngView, 5000),
    });

    // Listen for Place Selection
    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        const location = place.geometry.location;
        this.map.setCenter(location);
      }
    });
  }

  initFallbackMap(): void {
    const currentLatLng = this.getLocationPoints();
    this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
      center: new google.maps.LatLng(currentLatLng.lat, currentLatLng.lng),
      zoom: 14,
      mapId: "GM_MAP_ID",
    });

    this.initDrawingManager();
    this.loadDefaultShapes();
    this.initAutoSearch(currentLatLng);
  }

  createBoundsAroundLocation(location: any, radius: number): google.maps.LatLngBounds {
    const circle = new google.maps.Circle({
      center: location,
      radius: radius // Radius in meters
    });
    return circle.getBounds() as google.maps.LatLngBounds;
  }

  getLocationPoints(): { lat: number, lng: number } {

    if (this.defaultShapes.length === 0) return this.defaultLocation;

    const shape = this.defaultShapes.find(x => x.type.toLowerCase() === this.drawingMode);

    if (!shape) return this.defaultLocation;

    if (shape.type === 'Polygon') {
      return { lat: shape.polygon.coordinates[0][0], lng: shape.polygon.coordinates[0][1] }; // Return the first coordinate for a Polygon
    } else if (shape.type === 'Circle') {

      return { lat: shape.circle.center[0], lng: shape.circle.center[1] }; // Return the center coordinate for a Circle
    } else {
      return this.defaultLocation;
    }
  }
  drawOuterShape() {
    if (this.outerShape.type === 'Polygon') {
      const formattedObj: any = {}
      formattedObj.coordinates = [];
      for (let i = 0; i < this.outerShape.polygon.coordinates.length; i++) {
        formattedObj.coordinates.push({ lat: this.outerShape.polygon.coordinates[i][0], lng: this.outerShape.polygon.coordinates[i][1] })
      }

      const newCenter = new google.maps.LatLng(formattedObj.coordinates[0].lat, formattedObj.coordinates[0].lng);
      // Check if the map is correctly initialized
      if (this.map) {
        this.map.setCenter(newCenter);
      } else {
        console.error("Google map is not initialized");
      }

      this.outerPolygon = new google.maps.Polygon({
        paths: formattedObj.coordinates,
        fillColor: '#90D5FF',
        fillOpacity: 0.5,
        strokeWeight: 2,
        strokeColor: '#90D5FF',
        map: this.map,
      });
    } else {
      const formattedObj: any = {
        coordinates: { center: { lat: this.outerShape.circle.center[0], lng: this.outerShape.circle.center[1] } },
        radius: this.outerShape.circle.radius
      }
      const newCenter = new google.maps.LatLng(formattedObj.coordinates.center.lat, formattedObj.coordinates.center.lng);
      // Check if the map is correctly initialized
      if (this.map) {
        this.map.setCenter(newCenter);
      } else {
        console.error("Google map is not initialized");
      }

      this.outerCircle = new google.maps.Circle({
        strokeColor: "#90D5FF",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#90D5FF",
        fillOpacity: 0.35,
        map: this.map,
        center: formattedObj.coordinates.center,
        radius: formattedObj.radius,
      });
    }
  }

  loadDefaultShapes(): void {
    if (this.outerShape) {
      this.drawOuterShape();
    }


    this.defaultShapes.forEach((shape) => {
      if (shape.type === 'Polygon' && this.drawingMode === google.maps.drawing.OverlayType.POLYGON) {

        const formattedObj: any = {}
        formattedObj.coordinates = [];
        for (let i = 0; i < shape.polygon.coordinates.length; i++) {
          formattedObj.coordinates.push({ lat: shape.polygon.coordinates[i][0], lng: shape.polygon.coordinates[i][1] })
        }

        const polygon = new google.maps.Polygon({
          paths: formattedObj.coordinates,
          fillColor: '#00FF00',
          fillOpacity: 0.5,
          strokeWeight: 2,
          strokeColor: '#0000FF',
          editable: true,
          // draggable: true,
          map: this.map,
        });

        this.currentOverlay = polygon;
        // this.shapes.push(polygon);
        this.addDeleteIcon(polygon);
      } else if (shape.type === 'Circle' && this.drawingMode === google.maps.drawing.OverlayType.CIRCLE) {

        const formattedObj: any = {
          coordinates: { center: { lat: shape.circle.center[0], lng: shape.circle.center[1] } },
          radius: shape.circle.radius
        }
        const circle = new google.maps.Circle({
          center: formattedObj.coordinates.center,
          radius: formattedObj.radius,
          fillColor: '#00FF00',
          fillOpacity: 0.4,
          strokeWeight: 1,
          strokeColor: '#0000FF',
          editable: true,
          // draggable: true,
          map: this.map,
        });
        this.currentOverlay = circle;
        // this.shapes.push(circle);
        this.addDeleteIcon(circle);
      }

      this.getAllPaths();
    });
  }

  addDeleteIcon(overlay: google.maps.Polygon | google.maps.Circle): void {
    const position = this.getOverlayPosition(overlay);
    if (!position) return;

    // const deleteIcon = new google.maps.Marker({
    //   position,
    //   map: this.map,
    //   icon: {
    //     url: 'https://img.icons8.com/ios-filled/50/ff0000/trash.png',
    //     scaledSize: new google.maps.Size(20, 20),
    //   },
    //   clickable: true,
    // });
    const deleteIconContent = document.createElement('div');
    deleteIconContent.innerHTML = `
      <div style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; cursor: pointer;">
        <img 
          src="https://img.icons8.com/ios-filled/50/ff0000/trash.png" 
          alt="Delete Icon" 
          style="width: 20px; height: 20px;"
        />
      </div>
    `;
    const deleteIcon = new google.maps.marker.AdvancedMarkerElement({
      map: this.map,
      position: position,
      // icon: {
      //   url: 'https://img.icons8.com/ios-filled/50/ff0000/trash.png',
      //   scaledSize: new google.maps.Size(20, 20),
      // },
      content: deleteIconContent, // Custom HTML content
      gmpClickable: true
    })

    // Event listener to delete the shape when the icon is clicked
    google.maps.event.addListener(deleteIcon, 'click', () => {
      overlay.setMap(null);
      // deleteIcon.setMap(null);
      deleteIcon.map = null;
      this.currentOverlay = null;
      // this.shapes.forEach((storedShape, index) => {
      //   if (storedShape === overlay) {
      //     this.shapes.removeAt(index);
      //   }
      // });
      this.getAllPaths();
    });

    // Listen to changes and update delete icon position dynamically
    if (overlay instanceof google.maps.Circle) {
      // Update delete icon when radius or center changes
      google.maps.event.addListener(overlay, 'radius_changed', () => {
        this.updateDeleteIconPosition(overlay, deleteIcon);
      });
      google.maps.event.addListener(overlay, 'center_changed', () => {
        this.updateDeleteIconPosition(overlay, deleteIcon);
      });
    } else if (overlay instanceof google.maps.Polygon) {
      // Update delete icon when the polygon is edited
      google.maps.event.addListener(overlay.getPath(), 'set_at', () => {
        this.updateDeleteIconPosition(overlay, deleteIcon);
      });
      google.maps.event.addListener(overlay.getPath(), 'insert_at', () => {
        this.updateDeleteIconPosition(overlay, deleteIcon);
      });
    }
  }

  updateDeleteIconPosition(overlay: google.maps.Polygon | google.maps.Circle, deleteIcon: google.maps.marker.AdvancedMarkerElement): void {
    if (!this.checkMapArea(overlay, overlay instanceof google.maps.Circle ? google.maps.drawing.OverlayType.CIRCLE : google.maps.drawing.OverlayType.POLYGON)) {
      // deleteIcon.setMap(null);
      deleteIcon.map = null;
      return;
    };

    const position = this.getOverlayPosition(overlay);
    if (position) {
      // deleteIcon.setPosition(position);
      deleteIcon.position = position;
    }
    this.getAllPaths();
  }

  initDrawingManager(): void {
    this.drawingManager = new (google.maps.drawing.DrawingManager as any)({
      drawingMode: null,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          // google.maps.drawing.OverlayType.CIRCLE,
          // google.maps.drawing.OverlayType.POLYGON,
          this.drawingMode
        ],
      },
      circleOptions: {
        fillColor: '#273746',
        fillOpacity: 0.4,
        strokeWeight: 1,
        clickable: true,
        editable: true,
        zIndex: 1,
      },
      polygonOptions: {
        fillColor: '#273746',
        fillOpacity: 0.4,
        strokeWeight: 1,
        clickable: true,
        editable: true,
        zIndex: 1,
      },
    });

    this.drawingManager.setMap(this.map);

    // Add event listener for shape creation
    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {

      if (this.outerShape && this.outerShape.type && !this.checkMapArea(event.overlay, event.type)) { return };
      if (this.currentOverlay) {
        // Prevent multiple overlays
        event.overlay.setMap(null);
        return;
      }

      this.currentOverlay = event.overlay;
      // this.addDeleteIcon(event.overlay);
      const overlay = event.overlay;
      const position = this.getOverlayPosition(overlay);

      if (position) {
        this.addDeleteIcon(overlay);
      }

      this.getAllPaths();
      // if (event.type === google.maps.drawing.OverlayType.POLYGON) {
      //   const polygon = overlay as google.maps.Polygon;
      //   this.shapes.push(polygon);
      //   polygon.setEditable(true);
      //   this.getAllPaths();
      // } else if (event.type === google.maps.drawing.OverlayType.CIRCLE) {
      //   const circle = overlay as google.maps.Circle;
      //   this.shapes.push(circle);
      //   circle.setEditable(true);
      //   this.getAllPaths();
      // }
    });
  }

  createPolygon(paths: google.maps.MVCArray<google.maps.MVCArray<google.maps.LatLng>>): void {
    const polygon = new google.maps.Polygon({
      fillColor: '#ffff00',
      fillOpacity: 0.6,
      strokeWeight: 2,
      strokeColor: '#0000ff',
      editable: true,
      draggable: true,
      paths: paths,
      map: this.map,
    });

    this.shapes.push(polygon);
    // this.addShapeClickListener(polygon);
    this.addDeleteIcon(polygon);
  }

  getGeoJSON(shape: google.maps.Polygon | google.maps.Circle): any {
    if (shape instanceof google.maps.Polygon) {
      const paths = shape.getPath().getArray().map((latLng) => ({
        lat: latLng.lat(),
        lng: latLng.lng(),
      }));
      return { type: 'Polygon', coordinates: paths };
    } else if (shape instanceof google.maps.Circle) {
      return {
        type: 'Circle',
        center: {
          lat: shape.getCenter().lat(),
          lng: shape.getCenter().lng(),
        },
        radius: shape.getRadius(),
      };
    }
  }

  private getOverlayPosition(overlay: google.maps.MVCObject): google.maps.LatLng | null {
    if (overlay instanceof google.maps.marker.AdvancedMarkerElement) {
      const position = overlay.position;
      if (position instanceof google.maps.LatLng) {
        return position; // Return LatLng directly
      } else if (position) {
        return new google.maps.LatLng(position.lat, position.lng); // Convert LatLngLiteral to LatLng
      }
      return null; // 
    } else if (overlay instanceof google.maps.Circle) {
      const center = overlay.getCenter();
      const radius = overlay.getRadius();
      return google.maps.geometry.spherical.computeOffset(center, radius + 30, 45); // 45 degrees for top-right
    } else if (overlay instanceof google.maps.Polygon || overlay instanceof google.maps.Polyline) {
      const path = overlay.getPath();
      return path.getLength() > 0 ? path.getAt(0) : null;
    } else if (overlay instanceof google.maps.Rectangle) {
      return overlay.getBounds()?.getCenter() || null;
    }
    return null;
  }

  checkMapArea(shape, type): boolean {
    // const shape = event.overlay;
    let isShapeCorrect = true;
    if (this.outerPolygon) {
      if (type === google.maps.drawing.OverlayType.POLYGON) {
        const path = shape.getPath();
        let isInside = true;

        path.forEach((latLng) => {
          if (!google.maps.geometry.poly.containsLocation(latLng, this.outerPolygon)) {
            isInside = false;
          }
        });

        if (!isInside) {
          alert("The polygon extends outside the allowed area.");
          shape.setMap(null); // Remove the shape
          isShapeCorrect = false;

        }
      }

      if (type === google.maps.drawing.OverlayType.CIRCLE) {
        const circle = shape as google.maps.Circle;
        const center = circle.getCenter();
        const radius = circle.getRadius();

        const circlePoints: google.maps.LatLng[] = [];
        const numPoints = 36; // Number of points to approximate the circle

        // Generate points along the circle's boundary
        for (let i = 0; i < numPoints; i++) {
          const angle = (i * 360) / numPoints;
          const point = google.maps.geometry.spherical.computeOffset(center, radius, angle);
          circlePoints.push(point);
        }

        let isInside = true;
        circlePoints.forEach((point) => {
          if (!google.maps.geometry.poly.containsLocation(point, this.outerPolygon)) {
            isInside = false;
          }
        });

        if (!isInside) {
          alert("The circle extends outside the allowed area.");
          circle.setMap(null); // Remove the circle
          isShapeCorrect = false;
        }
      }
    }
    if (this.outerCircle) {
      if (type === google.maps.drawing.OverlayType.POLYGON) {
        const path = shape.getPath();
        let isInside = true;

        path.forEach((latLng) => {
          const distance = google.maps.geometry.spherical.computeDistanceBetween(
            latLng,
            this.outerCircle.getCenter()
          );

          if (distance > this.outerCircle.getRadius()) {
            isInside = false;
          }
        });

        if (!isInside) {
          alert("The shape extends outside the allowed area.");
          shape.setMap(null); // Remove the shape
          isShapeCorrect = false;
        }
      }

      if (type === google.maps.drawing.OverlayType.CIRCLE) {
        const circle = shape as google.maps.Circle;
        const center = circle.getCenter();
        const radius = circle.getRadius();

        const distanceFromOuterCenter = google.maps.geometry.spherical.computeDistanceBetween(
          center,
          this.outerCircle.getCenter()
        );

        // Check if the drawn circle is entirely inside the outer circle
        if (distanceFromOuterCenter + radius > this.outerCircle.getRadius()) {
          alert("The circle extends outside the allowed area.");
          circle.setMap(null); // Remove the circle
          isShapeCorrect = false;
        }
      }
    }
    return isShapeCorrect;
  }

  getAllPaths() {
    const allPaths: any[] = [];
    // console.log(this.currentOverlay);
    const shape = this.currentOverlay;
    // this.shapes.forEach((shape) => {
    if (shape instanceof google.maps.Polygon) {
      // Get the paths of the Polygon
      const polygonPaths = shape.getPath().getArray().map((latLng) => ([
        latLng.lat(),
        latLng.lng(),
      ]));
      if (this.drawingMode === google.maps.drawing.OverlayType.POLYGON) {
        allPaths.push({
          type: 'Polygon',
          polygon: { coordinates: polygonPaths },
        });
      }

    } else if (shape instanceof google.maps.Circle) {
      // Get the center and radius of the Circle
      const circleData = {
        type: 'Circle',
        circle: {
          center: [shape.getCenter().lat(),
          shape.getCenter().lng()],
          radius: shape.getRadius(),
        },

      };
      if (this.drawingMode === google.maps.drawing.OverlayType.CIRCLE) {
        allPaths.push(circleData);
      }

    }
    // });

    this.pathCoordinates.emit(allPaths[0]);
    return allPaths; // Return the collected paths
  }
}
